export default "__VITE_ASSET__DAGTHHPE__"